import {copilot} from '@cl/shared';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import campaignSetupContext, {
  placementsSummaryContext,
} from 'common/src/modules/campaigns/copilot/agents/campaignSetupAgent/campaignSetupAgent.context';
import campaignContext from 'common/src/modules/campaigns/copilot/contexts/campaignContext';
import campaignsLibraryContext from 'common/src/modules/campaigns/copilot/contexts/campaignsLibraryContext';
import {CLStore} from 'common/src/redux/store';

function initializeCampaignsUiContexts(store: CLStore) {
  copilot.uiContexts.registerUiContexts(BreadcrumbName.CampaignsLibrary, {
    description:
      'The campaigns library lists all campaigns in the account with filtering, search, and bulk actions.',
    contexts: [campaignsLibraryContext(store)],
  });

  copilot.uiContexts.registerUiContexts(BreadcrumbName.CampaignPage, {
    description:
      'This page displays the details and workflow of a single campaign, including its versions and configuration.',
    contexts: [campaignContext(store)],
  });

  copilot.uiContexts.registerUiContexts(BreadcrumbName.CampaignLogic, {
    description:
      'The campaign logic page is where the user builds and edits the campaign decision tree (map) using cards.',
    contexts: [campaignSetupContext(store), placementsSummaryContext(store)],
  });
}

export default initializeCampaignsUiContexts;
